import { FormSelectCombobox } from "app/pages/sales-intelligence/common-components/dropdown/FormSelectCombobox";
import { INDUSTRIES_CODE_NAMES, type IndustryCodeDto } from "app/pages/sales-intelligence/domain/industry/types/codes";

const CODES_DROPDOWN_WIDTH = 90;

const formatCode = (code: IndustryCodeDto): string => INDUSTRIES_CODE_NAMES[code];

interface IProps {
    value: IndustryCodeDto;
    codeOptions: readonly IndustryCodeDto[];
    onUpdate: (value: IndustryCodeDto) => void;
}

export const CodesDropdown = ({ value, onUpdate, codeOptions }: IProps) => (
    <FormSelectCombobox<IndustryCodeDto>
        fieldName="industry-codes"
        width={CODES_DROPDOWN_WIDTH}
        value={value}
        formatValue={formatCode}
        options={codeOptions}
        onChange={onUpdate}
    />
);
